import Button from '@mui/material/Button'
import React from 'react'

type Props = {
  isSubmitDisabled: boolean
  submitHandler: () => void
}

const ContactsUploadInitActions: React.FC<Props> = ({ submitHandler, isSubmitDisabled }) => (
  <Button
    id="contact-upload-button"
    variant="contained"
    color="primary"
    disabled={isSubmitDisabled}
    onClick={submitHandler}
  >
    Upload
  </Button>
)

export default ContactsUploadInitActions
